module.exports = __webpack_public_path__ + "static/media/IconUser.a2a47d56.svg";